var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isFetchMenu)?_c('el-container',{staticStyle:{"height":"100%"},attrs:{"direction":"vertical"}},[_c('layout-header'),_c('el-container',[_c('layout-sider'),_c('layout-main')],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }